// Module
var code = "<div class=\"hbox hbox-auto-xs hbox-auto-sm bg-light\">\n    <div ui-view=\"\"></div>\n\n</div>\n";
// Exports
module.exports = code;